import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./Checkbox.module.scss";

/**
 * Checkbox — native input with a token-styled box (primary fill + check when
 * checked). Label is the children. Replaces antd Checkbox in the IR module.
 */
const Checkbox = React.forwardRef(function Checkbox(
  { checked = false, onChange, disabled = false, className, children, ...rest },
  ref
) {
  return (
    <label className={cn(styles.wrap, disabled && styles.disabled, className)}>
      <input
        ref={ref}
        type="checkbox"
        className={styles.input}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...rest}
      />
      <span className={styles.box} aria-hidden="true" />
      {children != null ? <span className={styles.label}>{children}</span> : null}
    </label>
  );
});

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Checkbox;
